import Vue from "vue";
import SvgIcon from "@/components/SvgIcon"; // svg component
import SvgImg from "@/components/SvgImg"; // svg component

// register globally
Vue.component("svg-icon", SvgIcon);
Vue.component("svg-img", SvgImg);

const req = require.context("./svg", false, /\.svg$/);
const requireAll = requireContext => requireContext.keys().map(requireContext);
requireAll(req);
